import { httpClient } from '@shared/api';
import type {
  AudienceGrowth,
  AudienceOverview,
  AudienceUsersResponse,
  AudiencePeriod,
  AudiencePlatform,
} from '../model/types';

/**
 * API аудитории ботов (роутер audience, N-1).
 * Все эндпоинты под /assistants/{assistantId}/audience/...
 */
export const audienceApi = {
  async getOverview(assistantId: string): Promise<AudienceOverview> {
    const { data } = await httpClient.get<AudienceOverview>(
      `/assistants/${assistantId}/audience/overview`,
    );
    return data;
  },

  async getGrowth(
    assistantId: string,
    platform: AudiencePlatform,
    period: AudiencePeriod,
  ): Promise<AudienceGrowth> {
    const { data } = await httpClient.get<AudienceGrowth>(
      `/assistants/${assistantId}/audience/growth`,
      { params: { platform, period } },
    );
    return data;
  },

  async getUsers(
    assistantId: string,
    platform: AudiencePlatform,
    period: AudiencePeriod,
    search: string | undefined,
    limit = 50,
    offset = 0,
  ): Promise<AudienceUsersResponse> {
    const { data } = await httpClient.get<AudienceUsersResponse>(
      `/assistants/${assistantId}/audience/users`,
      {
        params: {
          platform,
          period,
          ...(search ? { search } : {}),
          limit,
          offset,
        },
      },
    );
    return data;
  },
};
